"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getStashboardKeys: ()=>getStashboardKeys,
    getStashboardData: ()=>getStashboardData,
    useStashboards: ()=>useStashboards
});
const _react = require("react");
const _dayjs = /*#__PURE__*/ _interopRequireDefault(require("dayjs"));
const _relativeTime = /*#__PURE__*/ _interopRequireDefault(require("dayjs/plugin/relativeTime"));
const _ = require("../..");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
_dayjs.default.extend(_relativeTime.default);
const getStashboardKeys = async ({ member_id , type  })=>{
    const response = await _.api.get(`/native_app/v2/stashboard?member_id=${member_id}&type=${type}`);
    return response;
};
const getStashboardData = async (payload, opts)=>{
    const response = await _.api.get(`/native_app/v1/stashboard/${payload.stashboard_key}?type=${payload.type}`, opts);
    response._key = payload.stashboard_key;
    return response;
};
const useStashboards = ()=>{
    const { member , stashboards , setStashboardKeys , setStashboards , isPreparingData  } = (0, _.useSpringBigStore)();
    const { expirationDateInDays  } = (0, _.useAppSettings)();
    const [isLoaded, setIsLoaded] = (0, _react.useState)(false);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const refetch = async ()=>{
        setIsLoaded(false);
        await fetch();
    };
    const handleDate = (date)=>{
        if (!date) {
            return false;
        }
        if (!expirationDateInDays && expirationDateInDays !== 0) {
            return date;
        }
        const now = (0, _dayjs.default)();
        const msgSentAt = (0, _dayjs.default)(date * 1000);
        const msgDateDiff = now.diff(msgSentAt, 'day');
        if (msgDateDiff >= expirationDateInDays) {
            return false;
        }
        return date;
    };
    const fetch = async ()=>{
        if (!member || isPreparingData) {
            return;
        }
        setIsLoading(true);
        let stashboardType = 'push';
        if (window?.location) {
            stashboardType = 'sms';
        }
        const alreadyFetched = stashboards?.map((s)=>s._key);
        const { stashboard_keys  } = await getStashboardKeys({
            member_id: member.id,
            type: stashboardType
        });
        setStashboardKeys(stashboard_keys);
        const newKeys = stashboard_keys.filter((k)=>!alreadyFetched?.includes(k.stashboard_key));
        const keysToFetch = newKeys.filter((key)=>!!handleDate(key.epoch));
        const newStashBoards = await Promise.all(keysToFetch.map(({ stashboard_key  })=>getStashboardData({
                stashboard_key,
                type: stashboardType
            })));
        const allStashboards = (stashboards || []).concat(newStashBoards);
        setStashboards(allStashboards);
        setIsLoading(false);
        setIsLoaded(true);
    };
    return {
        fetch,
        isLoading,
        handleDate,
        isLoaded,
        refetch
    };
};
